import { action } from 'satcheljs';
import type { CharmSuggestionsItem } from 'owa-calendar-charm-suggestions-data';

/**
 * Action to dismiss the charm suggestions
 */
export const dismissCharmSuggestions = action('dismissCharmSuggestions', (formId: string) => ({
    formId,
}));

/**
 * Action to show the charm suggestions
 */
export const showCharmSuggestions = action('showCharmSuggestions', (formId: string) => ({
    formId,
}));

/**
 * Action to update the value of the charm suggestions
 */
export const setCharmSuggestions = action(
    'setCharmSuggestions',
    (suggestions: CharmSuggestionsItem[], formId: string) => ({
        suggestions: suggestions,
        formId: formId,
    })
);
